/**
 * sessionStorage
 *
 * @param key å­å¨çé®åï¼ä¸æä¾åä½¿ç¨å±æ§å
 * @param defaultValue ç¼å­æ²¡ææ¾å°å¼æ¶ä½¿ç¨çé»è®¤å¼
 */
export function SessionStorage(key?: string, defaultValue?: any): (target: any, propName: string) => void;

/**
 * sessionStorage
 *
 * @param config å¯¹è±¡å½¢å¼ç keyãdefaultValueï¼æ¹ä¾¿çç¥ key åªå®ä¹ defaultValue çæåµï¼
 * æ¯å¦ï¼@SessionStorage({ defaultValue: xxx })
 */
export function SessionStorage(config?: { key?: string, defaultValue?: any }): (target: any, propName: string) => void;

export function SessionStorage(key?: string | { key?: string, defaultValue?: any }, defaultValue?: any) {
    return function (target: any, propName: string) {
        let rawKey: string;
        let cache: any;

        if (typeof key === 'string') {
            rawKey = key;
        } else if (key !== null && typeof key === 'object' && typeof key.key === 'string') {
            rawKey = key.key;
        } else {
            rawKey = propName;
        }

        Object.defineProperty(target, propName, {
            get() {
                return storageDecoratorGetHandler(cache, sessionStorage.getItem(rawKey), key, defaultValue);
            },
            set(value: any) {
                cache = value;
                sessionStorage.setItem(rawKey, JSON.stringify(value));
            }
        });
    };
}

export function storageDecoratorGetHandler(cache: any,
                                           curCache: any,
                                           key: string | { key?: string, defaultValue?: any },
                                           defaultValue: any) {
    if (cache === null || cache === undefined) {
        cache = JSON.parse(curCache);

        if (cache === null) {
            if (key !== null && typeof key === 'object') {
                return key.defaultValue;
            } else {
                return defaultValue;
            }
        } else {
            return cache;
        }
    } else {
        // å¤é¨åé cache ä¸ç´ç¼å­å¼ï¼è¥å¤ä¸ªå°æ¹ä½¿ç¨åä¸ä¸ªç¼å­ï¼ç¼å­å¼å¨å¶ä»å°æ¹æ¹åï¼ä½æ­¤å¤ cache è¿ä¿ççä»¥åçå¼ï¼
        // å¯¹æ­¤åä¸æ¬¡æ¯è¾ä»¥ä¾¿åæ¶ä¿®å¤è¿ç§æåµ
        if (JSON.stringify(cache) !== curCache) {
            cache = JSON.parse(curCache);
        }

        return cache;
    }
}